import React from 'react';
import { translate } from '../../../common/utility/DisplayPrep';

const defaultUiConfig = {
    name: 'Predicate Part',
    primaryKey: 'uuid',
    pageSize: 10,
    onFormMount: (data, hookFxns) => {
        if (data?.constraintType) {
            hookFxns.updateConstraintType(data.constraintType, true);
        }

        return null;
    },
    properties: {
        uuid: {
            rowDisplay: false,
            sortable: true,
            name: 'Uuid'
        },
        lastModId: {
            rowDisplay: false,
            sortable: true,
            name: 'Last Modified ID'
        },
        constraintType: {
            name: 'Concept Constraint Type',
            rowDisplay: false,
            sortable: false,
            // nullable: false,
            input: 'select',
            postChangeBind: (v, onChange, hookFxns) => {
                hookFxns.updateConstraintType(v);
            }
        },
        lastModDatetime: {
            rowDisplay: false,
            displayPrep: 'FullDate',
            name: 'Last Updated',
            additionalProperties: {
                Cell: ({ cell: { value } }) => {
                    return translate.ReadableDateTimeColumn(value);
                }
            }
        },
        createId: {
            rowDisplay: false,
            name: 'Create ID'
        },
        createDatetime: {
            rowDisplay: false,
            name: 'Create Datetime'
        }
    },
    newDoc: {
        cdsCodeSystemDTO: null,
        cdsListDTO: null,
        constraintType: undefined,
        createDatetime: null,
        createId: null,
        dtoState: 'NEW',
        lastModDatetime: null,
        lastModId: null,
        partId: null,
        relId: null,
        uuid: null
    }
};

export default defaultUiConfig;
